import { Edit2, Power } from "lucide-react";
import { Button } from "@/components/ui/button";

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "-";
  return `RM${parseFloat(value).toFixed(2)}`;
};

const ProductCard = ({ product, onEdit, onToggleStatus }) => {
  const isActive = product.isActive;

  return (
    <div
      className={`bg-white border border-slate-200 rounded-2xl p-5 hover:border-[#193f7d]/30 transition-colors shadow-sm flex flex-col gap-4 ${
        isActive ? "" : "opacity-60"
      }`}
      data-testid={`product-card-${product.id}`}
    >
      {/* Product Name & Category */}
      <div>
        <h3 className="text-lg font-medium text-slate-800" data-testid={`product-name-${product.id}`}>
          {product.name}
        </h3>
        <p className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500 mt-1" data-testid={`product-category-${product.id}`}>
          {product.category}
        </p>
      </div>

      {/* Unit & Costs */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500">Unit</p>
          <p className="text-base text-slate-800 mt-1" data-testid={`product-unit-${product.id}`}>{product.unit}</p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500">Unit Cost</p>
          <p className="font-mono font-semibold tracking-tight text-slate-900 mt-1" data-testid={`product-unit-cost-${product.id}`}>
            {formatCurrency(product.unitCost)}
          </p>
        </div>
      </div>

      <div>
        <p className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500">Default Selling Price</p>
        <p className="font-mono font-semibold tracking-tight text-slate-900 mt-1" data-testid={`product-default-price-${product.id}`}>
          {formatCurrency(product.defaultPrice)}
        </p>
      </div>

      {/* Remark */}
      {product.remark && (
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500">Remark</p>
          <p className="text-sm text-slate-600 mt-1" data-testid={`product-remark-${product.id}`}>{product.remark}</p>
        </div>
      )}

      {/* Status & Actions */}
      <div className="flex items-center justify-between pt-2 border-t border-slate-100">
        <span
          className={`${
            isActive
              ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
              : "bg-slate-100 text-slate-500 border border-slate-200"
          } px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider`}
          data-testid={`product-status-${product.id}`}
        >
          {isActive ? "Active" : "Inactive"}
        </span>

        <div className="flex gap-2">
          <Button
            onClick={() => onEdit(product)}
            variant="outline"
            size="icon"
            className="border border-slate-200 hover:border-[#193f7d] hover:text-[#193f7d] rounded-full transition-colors bg-white h-10 w-10"
            data-testid={`edit-product-btn-${product.id}`}
          >
            <Edit2 className="w-4 h-4" />
          </Button>
          <Button
            onClick={() => onToggleStatus(product.id)}
            variant="outline"
            size="icon"
            className="border border-slate-200 hover:border-[#193f7d] hover:text-[#193f7d] rounded-full transition-colors bg-white h-10 w-10"
            data-testid={`toggle-status-btn-${product.id}`}
          >
            <Power className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;